module.exports = ["StableCoin"]